var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6025 36.832H2.60254C1.49798 36.832 0.602539 35.9366 0.602539 34.832V0.832031H4.60254V32.832H36.6025V36.832ZM33.8565 26.832L25.5165 18.668L21.0605 23.032C20.2959 23.775 19.0791 23.775 18.3145 23.032L8.60254 13.52L11.3485 10.832L19.6885 18.996L24.1425 14.632C24.9071 13.889 26.1239 13.889 26.8885 14.632L36.6025 24.144L33.8565 26.832Z",
    fill: "#B84034"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartDown);
export default __webpack_public_path__ + "static/media/chartDown.9ad2695aa737321faece86ab5d210cc7.svg";
export { ForwardRef as ReactComponent };